export const ONBOARDING_RESUME_SOURCES = [
  "resume-card",
  "resume-banner",
  "resume-email",
] as const;

export type OnboardingResumeSource = (typeof ONBOARDING_RESUME_SOURCES)[number];

export const ONBOARDING_RESUME_SOURCE_PARAM = "src";
export const RETURNS_RESUME_ENTRY_STEP_ID = "resume-entry";

export function parseOnboardingResumeSource(
  value: string | null | undefined,
): OnboardingResumeSource | undefined {
  return ONBOARDING_RESUME_SOURCES.find((source) => source === value);
}
